const headers = [ 
  {
    label: "ผู้ใช้งาน",
    field: "fullname",
  },
  {
    label: "Action",
    field: "UserAction",
  },
  {
    label: "ชื่อเมนู",
    field: "menu",
  },
  {
    label: 'Ip / Device',
    field: 'device',
  },
  {
    label: 'วันที่เข้าใช้งาน',
    field: 'createDateStr',
  },
  // {
  //   label: "Action",
  //   field: "action",
  // },
];

export default headers;
